import { gql } from '@apollo/client';
import { DetailsFragment } from './fragments/details';
import { EnrichmentsFragment } from './fragments/enrichments';
import { WorkflowStateFragment } from './fragments/workflow_state';

export const LIST_CASES = gql`
  query ListCases {
    listCases {
      items {
        id
        role
        workflow_state {
          ...WorkflowState
        }
        enrichments {
          ...Enrichments
        }
        details {
          ...Details
        }
      }
    }
  }
  ${WorkflowStateFragment}
  ${EnrichmentsFragment}
  ${DetailsFragment}
`;

// fully expanded query for reference
/*
export const LIST_CASES = gql`
  query ListCases {
    listCases {
      items {
        id
        report_path
        details {
          ...Details
        }
        company_info {
          ...CompanyInfo
        }
        enrichments {
          ...Enrichments
        }
        workflow_state {
          ...WorkflowState
        }
        risks {
          ...RiskItems
        }
      }
    }
  }
  ${DetailsFragment}
  ${CompanyInfoFragment}
  ${EnrichmentsFragment}
  ${WorkflowStateFragment}
  ${RiskItemsFragment}
`;
*/
